<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-11-10 20:06:36
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-10 16:47:06
-->
<template>
	<div class="mt-24 yx-form-wrap">
		<Search @onSearch="onSubmit" @onReset="onClear">
			<el-form :inline="true" :model="formData" label-width="120px">
				<el-form-item label="达人昵称">
					<el-input v-model="formData['anchor_name']" placeholder="请输入达人昵称"></el-input>
				</el-form-item>
				<el-form-item :label="drName">
					<dr-partner-select v-model="formData['talent_user_id']"></dr-partner-select>
				</el-form-item>
				<el-form-item label="达人招商">
					<contact-select v-model="formData['open_id']"></contact-select>
				</el-form-item>
				<el-form-item :label="zsName">
					<zs-partner-select v-model="formData['bd_user_id']"></zs-partner-select>
				</el-form-item>
				<el-form-item label="合作ID">
					<el-input v-model="formData['cooperate_id']" placeholder="请输入合作ID"></el-input>
				</el-form-item>
				<el-form-item label="商品ID">
					<el-input v-model="formData['product_id']" placeholder="请输入商品ID"></el-input>
				</el-form-item>
				<el-form-item label="商品名称">
					<el-input v-model="formData['product_name']" placeholder="请输入商品名称"></el-input>
				</el-form-item>
				<el-form-item label="二级团长" prop="team_institution_id" v-if="!$isSp(platformId)">
					<institution-select v-model="formData['team_institution_id']" :platformId="platformId"></institution-select>
				</el-form-item>
				<el-form-item label="商品类型" prop="product_type" v-if="!$isSp(platformId)">
					<el-select v-model="formData.product_type" clearable placeholder="请选择">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in goodsTypeList" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="样品状态" v-if="tabName == '1'">
					<el-select v-model="formData['delivery_status']" @change="selectFun" clearable placeholder="请选择样品状态">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in deliveryArr" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="部门" v-if="showDeptSelect && isAllDataView">
					<deptTreeSelect v-model="formData['deptIds']" :collapseTags="true" size="small" @input="deptTreeSelectFun" ref="deptTreeSelect" />
				</el-form-item>
				<el-form-item label="授权团长">
					<commander-select :platformId="platformId" v-model="formData['authority_id']"></commander-select>
				</el-form-item>
				<el-form-item>
					<MultiInput ref="multiInput" @change="handleMultiChange" :labelWidth="120" v-model="formData['anchor_account']" :options="multiList" />
				</el-form-item>
				<!-- <el-form-item label="达人抖快号">
					<el-input v-model="formData['anchor_account']" placeholder="请输入达人抖快号"></el-input>
				</el-form-item> -->
				<el-form-item label="带货类型" v-if="tabName != '0'">
					<el-select v-model="formData['sell_goods_type']" clearable filterable :placeholder="`请选择`">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in commerceArr" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="佣金模式" v-if="$isPlatOr(platformId, ['Dy','All'])">
					<el-select v-model="formData['commissionMode']" clearable placeholder="全部">
						<el-option label="全部" value="all"></el-option>
						<el-option label="双佣商品" value="double"></el-option>
						<el-option label="非双佣商品" value="single"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</Search>
	</div>
</template>

<script>
import throttle from 'lodash/throttle';
import ZsPartnerSelect from '@/components/zsPartnerSelect';
import ContactSelect from '@/components/contactSelect';
import DrPartnerSelect from '@/components/drPartnerSelect';
import { zsRoleType, drRoleType, AUDIT_STATUS_OPEN, AUDIT_STATUS_CLOSE } from '@/utils/dataMap';
import deptTreeSelect from '@/components/business/deptTreeSelect/deptTreeSelect.vue';
import { mapGetters } from 'vuex';
import { statusList } from '@/api/cooperationProgress';
import commanderSelect from '@/components/commanderSelect/index.vue';
import { goodsTypeList } from '@/utils/newDataMap/shopManage';
import InstitutionSelect from '@/components/business/institutionSelect/index.vue';
import { formatPlatformName } from '@/filters';
export default {
	name: 'search',
	components: {
		InstitutionSelect,
		ZsPartnerSelect,
		ContactSelect,
		DrPartnerSelect,
		deptTreeSelect,
		commanderSelect,
	},
	props: {
		tabName: {
			type: String,
			default: '0',
		},
		delivery_status: {
			type: String,
			default: '',
		},
		sampleAudit: {
			type: [String, Number],
			default: AUDIT_STATUS_CLOSE,
		},
		platformId: {
			type: [String, Number],
			default: 0,
		},
	},
	data() {
		return {
			formData: {
				delivery_status: '',
				sell_goods_type: '-1',
				deptIds: [],
				authority_id: '',
				team_institution_id: '',
				anchor_platformId: '',
				anchor_search_platform_id: '',
			},
			otherStatus: [],
			freeOrderTime: '',
			labelWidth: '140px',
			cateArr: [
				{
					label: '关闭推广',
					value: '0',
				},
				{
					label: '推广中',
					value: '1',
				},
			],
			commerceArr: [
				{
					label: '全部',
					value: '-1',
				},
				{
					label: '不限',
					value: '0',
				},
				{
					label: '直播',
					value: '1',
				},
				{
					label: '短视频',
					value: '2',
				},
			],
			type: '',
			goodsTypeList,
		};
	},
	computed: {
		...mapGetters(['showDeptSelect', 'isAllDataView', 'canShowPlatformList']),
		zsName() {
			return zsRoleType.name;
		},
		drName() {
			return drRoleType.name;
		},
		deliveryArr({ sampleAudit }) {
			let arr = [
				{
					label: '待发货',
					value: '1',
					isShow: true,
				},
				{
					label: '已发货',
					value: '2',
					isShow: true,
				},
				{
					label: '运输中',
					value: '3',
					isShow: true,
				},
				{
					label: '已到货',
					value: '4',
					isShow: true,
				},
				{
					label: '拒绝带货',
					value: '400',
					isShow: true,
				},
				{
					label: '拒绝发货',
					value: '401',
					isShow: true,
				},
				{
					label: '待审核',
					value: '801',
					isShow: sampleAudit === AUDIT_STATUS_OPEN,
				},
				{
					label: '审核不通过',
					value: '802',
					isShow: sampleAudit === AUDIT_STATUS_OPEN,
				},
			];
			return arr.filter(item => item.isShow);
		},
		multiList() {
			if (this.platformId == dataMap.PLATFORM_ALL.value) {
				return this.canShowPlatformList.map(item => {
					return {
						label: this.$isKs(item.value) ? '快手号/快手id' : formatPlatformName(item.value, 'unify'),
						value: item.value,
					};
				});
			} else {
				return [
					{
						label: this.$isKs(this.platformId) ? '快手号/快手id' : formatPlatformName(dataMap.PLATFORM_OBJ[this.platformId].value, 'unify'),
						value: dataMap.PLATFORM_OBJ[this.platformId].value,
					},
				];
			}
		},
	},
	created() {
		const { tabName, delivery_status } = this;
		if (tabName === '1') {
			this.formData.delivery_status = delivery_status;
		}
		this.searchList();
	},
	methods: {
		async searchList() {
			//其他状态
			const res = await statusList({});
			if (res.code === 0) {
				this.otherStatus = res.data;
			}
		},
		onClear() {
			this.formData = {
				delivery_status: '',
				deptIds: [],
				authority_id: '',
				team_institution_id: '',
				anchor_platformId: '',
				anchor_search_platform_id: '',
				sell_goods_type: '-1',
			};
			this.freeOrderTime = '';
			this.type = '0';
			this.$refs.multiInput.reset();
			this.onSubmit();
		},
		handleMultiChange(val) {
			if (!val.value) {
				this.formData['anchor_platformId'] = '';
				this.formData['anchor_search_platform_id'] = '';
				return;
			}
			this.formData['anchor_platformId'] = val.label.id;
			this.formData['anchor_search_platform_id'] = val.label.id;
		},
		changeTimed(value) {
			const [start, end] = value || [];
			this.formData.from_time = start ? Date.parse(start) / 1000 - 8 * 3600 : '';
			this.formData.to_time = end ? Date.parse(end) / 1000 + 16 * 3600 - 1 : '';
		},
		onSubmit: throttle(function () {
			const { type } = this;
			let copyFrom = JSON.parse(JSON.stringify(this.formData));
			if (type === '5') {
				copyFrom.delivery_status = undefined;
				copyFrom.is_refuse_delivery = '1';
			} else if (type === '6') {
				copyFrom.delivery_status = undefined;
				copyFrom.is_affirm = '3';
			}
			this.$emit('onSubmit', copyFrom);
		}, 1000),
		selectFun(e) {
			this.type = e;
		},
		deptTreeSelectFun(value) {
			this.formData.deptIds = value?.length ? value.split(',') : [];
		},
	},
};
</script>
